<div class="country-select" [class.country-select--disabled]="disabled">
  <input
    type="text"
    class="country-select__input"
    [value]="searchText"
    [placeholder]="isOpen ? searchPlaceholder : placeholder"
    [disabled]="disabled"
    (focus)="onFocus()"
    (input)="onInput($any($event.target).value)"
    (blur)="onBlur()"
    autocomplete="off"
  />
  <button
    type="button"
    class="country-select__clear"
    *ngIf="selectedCountry && !isOpen"
    (mousedown)="clearSelection($event)"
    title="Очистить"
  >×</button>

  <ul class="country-select__dropdown" *ngIf="isOpen">
    <li
      *ngFor="let country of filteredCountries"
      class="country-select__option"
      [class.country-select__option--selected]="country.id === selectedCountry?.id"
      (mousedown)="selectCountry(country)"
    >
      {{ getCountryName(country) }}
    </li>
    <li class="country-select__empty" *ngIf="filteredCountries.length === 0">Ничего не найдено</li>
  </ul>
</div>
